import * as React from 'react';
import * as _ from 'underscore';

import { SignInUrlBuilder } from '@tableau/shared-urls';

import { ProcessAndRemoveSamlQueryWrapper } from '../../../app/spaces/RouterHelpers/ProcessAndRemoveSamlQueryWrapper';
import { AngularDirective } from '../../../common/react/components/AngularDirective';
import { ILoginScope } from '../../../ts/controllers/LoginCtrl';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { DefaultServerTitleWrapper } from './DefaultServerTitleWrapper';

export interface SignInProviderProps extends ReactDirectiveProps {
  readonly routeLocationSearch: string;
}

const template = `<div ng-controller="LoginCtrl" ng-include="'login.html'"></div>`;

export class SignInProvider extends React.Component<SignInProviderProps> {
  public render() {
    return (
      <DefaultServerTitleWrapper>
        <ProcessAndRemoveSamlQueryWrapper>
          <div>
            <AngularDirective template={'<tb:app-banner />'} angularContext={this.props.angularContext} />
          </div>
          <div>
            <AngularDirective
              template={template}
              angularContext={this.props.angularContext}
              setupScope={this.setupScope}
            />
          </div>
        </ProcessAndRemoveSamlQueryWrapper>
      </DefaultServerTitleWrapper>
    );
  }

  private setupScope = (scope: ng.IScope) => {
    const childScope = scope.$new() as ILoginScope;
    childScope.signinQueryParams = SignInUrlBuilder.queryParamsFromQuery(this.props.routeLocationSearch);
    return childScope;
  }
}
